export var ALIGNMENT = 'alignment';
export var ALIGNMENT_LEFT = 'Left';
export var ALIGNMENT_RIGHT = 'Right';
export var LANGUAGE_URL = '/Global/Header/TopNavigation/language';
export var LEFT_ALIGNED_NAV_ITEMS = 'left';
export var NAV_TYPE = 'navType';
export var NAV_TYPE_PRIMARY = 'Primary';
export var NAV_TYPE_SECONDARY = 'Secondary';
export var RIGHT_ALIGNED_NAV_ITEMS = 'right';
export var USER_ITEM_DISPLAY_NAME = 'user';
export var MAX_NAV_ITEMS = 4;
// Content editor should set correct item names
export var FIND_DEALER_NAV_ITEM_ID = 'FindDealer';
export var FIND_DEALER_NAV_ITEM_MOBILE_ID = 'FindDealer-Mobile';
export var FIND_DEALER_NAV_ITEM_MOBILE_LEFT_ID = 'FindDealer-Mobile-left';
export var NAV_GTM_INTERACTION_TYPE = 'cta: nav click';
export var variant1 = 'variant1';
export var variant2 = 'variant2';
export var variant3 = 'variant3';
export var variant4 = 'variant4';
export var variant5 = 'variant5';
export var variant6 = 'variant6'; // Acura Footer variant
export var variant7 = 'variant7'; // Honda Footer variant
export var variant8 = 'variant8'; // PE variant
